'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

require('../../moment/moment-and-timezone-init');

var _legacyI18nInit = require('../../internal/legacyI18nInit');

var _es = require('i2l?mode=very-lazy&query=sporks!moment/locale/es');

var _es2 = _interopRequireDefault(_es);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Provider) {
  return Provider.register(_es2.default, {
    localeMapper: _legacyI18nInit.momentLocaleMapper,
    getLocales: _legacyI18nInit.getLangEnabledLocales
  }).then(function () {
    var validMomentLocale = _legacyI18nInit.momentMappings[I18n.locale] || _legacyI18nInit.momentMappings[I18n.locale.substring(0, 2)] || _legacyI18nInit.defaultLanguage;
    return I18n.moment.locale(validMomentLocale);
  });
};
// To do: We currently have to point to an arbitrary locale.
// Need extra lazy loader


module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.520/js/init/register/lazy/registerMoment.js
// module id = 140
// module chunks = 177 178